<template>
  <div class="MobileGeneral">
    <div class="mobile-header">
      <div class="header-content">
        <div class="header-title">
          <h2>Produtos</h2>
          <p>Gerencie seus produtos</p>
        </div>
        <b-button class="BtnRegister" @click="openModalToReceive">
          <div class="btn-icon">
            <b-icon-plus scale="1.2"></b-icon-plus>
          </div>
          <span>Novo Produto</span>
        </b-button>
      </div>
    </div>

    <transition name="slide-fade">
      <div v-if="showFilters" class="mobile-filters-container">
        <div class="filter-row">
          <b-form-select
            v-model="type"
            :style="
              showFilterTypes && `border-left: none; border-radius: 0 0 0 0`
            "
            :options="filterCombobox"
            @change="handleShowFilterTypes"
            size="sm"
            class="mobile-select"
          ></b-form-select>
        </div>

        <div class="filter-row search-row">
          <b-input
            v-model="textPesquisa"
            placeholder="Buscar..."
            class="mobile-search-input"
            @keyup.enter="readProducts(page)"
          ></b-input>
          <b-button @click="readProducts(page)" class="btn-search-mobile">
            <b-icon-search></b-icon-search>
          </b-button>
        </div>
      </div>
    </transition>

    <div class="status-scroll-container">
      <div class="status-card products-card">
        <div class="status-icon">
          <b-icon-box-seam scale="1.2"></b-icon-box-seam>
        </div>
        <div class="status-info">
          <span class="status-count">{{ this.counter.productCount }}</span>
          <span class="status-label">Produtos</span>
        </div>
      </div>
    </div>
    <div class="header-actions">
      <b-button class="btn-toggle-filters" @click="showFilters = !showFilters">
        <b-icon-funnel-fill></b-icon-funnel-fill>
      </b-button>
    </div>
    <div class="card-list-container">
      <div
        v-for="product in dataProducts"
        :key="product.id"
        class="product-card"
        @click="findById(product)"
      >
        <div class="card-header-mobile">
          <div class="product-id">
            <b-icon-box class="product-avatar"></b-icon-box>
            <div class="id-info">
              <span class="product-code">#{{ product.codigo }}</span>
              <span class="product-ref">{{ product.codReferencia || "0000" }}</span>
            </div>
          </div>
          <div class="card-actions">
            <b-button
              variant="link"
              class="action-btn delete-btn"
              @click.stop="destroyProduct(product.id)"
            >
              <b-icon-trash scale="0.9"></b-icon-trash>
            </b-button>
          </div>
        </div>

        <div class="card-body-mobile">
          <div class="product-info">
            <h4 class="product-name">{{ product.nome }}</h4>
            <div class="price-info">
              <div class="price-item">
                <span class="price-text">
                  {{
                    product.valorVenda.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="card-footer">
          <div class="product-status active">
            <span>Produto Ativo</span>
          </div>
        </div>
      </div>

      <div v-if="!dataProducts.length" class="empty-state">
        <b-icon-inbox scale="2"></b-icon-inbox>
        <p>Nenhum produto encontrado.</p>
      </div>
    </div>
    <b-modal
      id="modal-excluir"
      hide-footer
      hide-header
      centered
      size="md"
      title="Excluir"
      no-close-on-backdrop
    >
      <div>
        <h6 class="textModalBill">Deseja excluir a compra?</h6>
        <div class="ctnLoadDelAll" v-if="spinDelete">
          <b-spinner class="spin"></b-spinner>
          <span>Aguarde ...</span>
        </div>
        <div v-else class="ctnDelAll">
          <button
            class="btnContentConfirmedWhiteDelAll"
            @click="$bvModal.hide('modal-excluir')"
          >
            Não, obrigado!
          </button>
          <button class="btnContentConfirmedDelAll" @click="deleteAll">
            Sim, quero excluir!
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import whatsapp from "../../../assets/whatsapp.svg";
import serviceRegisters from "../../../services/serviceRegisters";
import mixinSearchProducts from "../../../mixins/Products/Search";
import api from "../../../services/axios";

export default {
  props: {
    getAllCustomer: {
      type: Boolean,
    },
  },
    mixins: [mixinSearchProducts],
  data() {
    return {
      counter: {},
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      dataProducts: [],
      page: 1,
      whatsapp: whatsapp,
      filterCombobox: [
        { value: "nome", text: "Nome" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "celular", text: "Contato" },
        { value: "status", text: "Status" },
        { value: "", text: "Todos" },
      ],
      filterTypes: [
        { value: "includes", text: "Contém" },
        { value: "start", text: "Inicia por" },
      ],
      filterType: "includes",
      showFilterTypes: false,
      showFilters: false,
      spinDelete: false,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_PRODUCT",
    ]),
    async deleteAll() {
      this.spinDelete = true;
      try {
        this.$bvModal.hide("modal-excluir");
        return this.$toast.open({
          message: "Deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: `${error.response}`,
            type: "error",
          });
      } finally {
        this.spinDelete = false;
      }
    },
    async findById(product) {
      try {
        const result = await api.get(`/products/${product.id}`);
        
        const productData = result.data.data || result.data;
        this.openModalToReceive(productData);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um erro ao buscar o produto!",
            type: "error",
          });
        }
      }
    },
    openModalToReceive(products) {
      this.SET_DATA_SEARCH_FROM_PRODUCT(products);

      const name = "product";
      this.ALTER_TYPE_REGISTER(name);
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    openModalDetails(detailsProduct) {
      this.SET_DATA_SEARCH_FROM_PRODUCT(detailsProduct);

      this.ALTER_TYPE_REGISTER("product");
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    redirectWhatsApp(number) {
      if (number) {
        const formatedNumber = number.replace(/\D/g, "");
        const url = `https://wa.me/55${formatedNumber}`;
        window.open(url, "_blank");
      }
    },

    handleShowFilterTypes() {
      const types = ["nome", "cpfCnpj", "celular", "endereco", "cidade", "cep"];

      if (types.includes(this.type)) {
        this.showFilterTypes = true;
        return;
      }

      this.showFilterTypes = false;
    },
        async destroyProduct(productId) {
      try {
        await api.delete(`/products/${productId}`);
        this.readProducts(this.page);
        return this.$toast.open({
          message: "Produto deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: "Erro ao deletar produto",
            type: "error",
          });
      }
    },

    async readProducts(page) {
      try {
        this.spinGeneral = true;
        const {
          data: { data },
        } = await api.get(
          `/products?q=${this.textPesquisa}&type=${this.type}&page=${page}&filterType=${this.filterType}`
        );
        this.dataLengthProduct = data.length;
        this.dataProducts = data;
      } catch (error) {
        return this.$toast.open({
          message: "Não foi possível listar os produtos",
          type: "warning",
        });
      } finally {
        this.spinGeneral = false;
      }
      if (this.dataLengthProduct < 8) {
        this.clearSearch();
      }
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      this.startDate = "";
      this.endDate = "";
    },

    async countAll() {
      try {
        this.counter = await serviceRegisters.countAll();
      } catch (error) {
        console.log(error.response);
      }
    },
  },
  computed: {
    ...mapState({
      isSearchRegisters: (state) => state.isSearchRegisters,
    }),
  },
  watch: {
    async getAllCustomer() {
      await this.readProducts(1);
    },
    isSearchRegisters() {
      this.readProducts(this.page);
    },
  },
  created() {
    this.countAll();
    this.readProducts(1);
  },
};
</script>
<style scoped>
.mobile-header {
  padding: 20px;
  width: 100%;
  background: linear-gradient(135deg, #006256 0%, #709e8a 100%);
  color: white;
  box-shadow: 0 8px 32px rgba(0, 98, 86, 0.3);
  position: relative;
  overflow: hidden;
}

.mobile-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

.header-title h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: white;
}

.header-title p {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.BtnRegister {
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
  color: #006256;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.BtnRegister:hover, .BtnRegister:focus {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  color: #006256;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.btn-icon {
  width: 24px;
  height: 24px;
  background: #006256;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.header-actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 5px 20px;
  background: rgba(0, 98, 86, 0.05);
}

.btn-toggle-filters {
  background: white;
  color: #006256;
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 12px;
  width: 44px;
  height: 44px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.btn-toggle-filters:hover {
  background: #006256;
  color: white;
  transform: scale(1.05);
}

.mobile-filters-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  padding: 20px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
}

.filter-row {
  margin-bottom: 16px;
}

.search-row {
  display: flex;
  gap: 12px;
  margin-bottom: 0;
}

.mobile-search-input {
  flex: 1;
  border-radius: 12px;
  height: 44px;
  border: 2px solid #e9ecef;
  padding: 0 16px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.mobile-search-input:focus {
  border-color: #006256;
  box-shadow: 0 0 0 3px rgba(0, 98, 86, 0.1);
}

.btn-search-mobile {
  background: linear-gradient(135deg, #006256, #709e8a);
  border: none;
  border-radius: 12px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 98, 86, 0.3);
  transition: all 0.3s ease;
}

.btn-search-mobile:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 98, 86, 0.4);
}

.status-scroll-container {
  display: flex;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(0, 98, 86, 0.03), rgba(112, 158, 138, 0.03));
}

.status-card {
  flex: 1;
  background: white;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.status-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.products-card {
  border-left: 4px solid #e67e22;
}

.status-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.products-card .status-icon {
  background: linear-gradient(135deg, #e67e22, #f39c12);
}

.status-info {
  display: flex;
  flex-direction: column;
}

.status-count {
  font-size: 18px;
  font-weight: 700;
  color: #006256;
  margin: 0;
}

.status-label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-list-container {
 padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.product-card {
  background: white;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.product-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #e67e22, #f39c12);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.product-card:active {
  transform: scale(0.98);
}

.product-card:hover::before {
  transform: scaleY(1);
}

.card-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 0 16px;
}

.product-id {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-avatar {
  font-size: 32px;
  color: #e67e22;
}

.id-info {
  display: flex;
  flex-direction: column;
}

.product-code {
  font-weight: 700;
  color: #006256;
  font-size: 14px;
}

.product-ref {
  font-size: 12px;
  color: #6c757d;
  font-family: 'Monaco', 'Menlo', monospace;
}

.card-actions {
  display: flex;
  gap: 8px;
}

.delete-btn {
  color: #dc3545;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.delete-btn:hover {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.card-body-mobile {
  padding: 0 16px 16px 16px;
}

.product-info {
  padding-left: 44px;
}

.product-name {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 8px 0;
}

.price-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.price-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.price-icon {
  color: #e67e22;
  font-size: 14px;
}

.price-text {
  font-size: 16px;
  color: #22c55e;
  font-weight: 600;
  flex: 1;
}

.card-footer {
  padding: 8px 16px;
  background: rgba(0, 98, 86, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.product-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.product-status.active {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.product-status.active::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
}

.empty-state {
  text-align: center;
  color: #a0aec0;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.6, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.mobile-select {
  border: 2px solid #e9ecef;
  border-radius: 12px;
  height: 44px;
  font-size: 16px;
  padding: 0 16px;
  transition: all 0.3s ease;
}

.mobile-select:focus {
  border-color: #006256;
  box-shadow: 0 0 0 3px rgba(0, 98, 86, 0.1);
}

@media (max-width: 380px) {
  .header-content {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
  
  .status-scroll-container {
    flex-direction: column;
  }
  
  .product-name {
    font-size: 16px;
  }
}

.textModalBill {
  text-align: center;
  color: #2d3748;
  margin-bottom: 20px;
}

.ctnLoadDelAll {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px;
}

.spin {
  color: #006256;
}

.ctnDelAll {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btnContentConfirmedWhiteDelAll {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 10px 20px;
  color: #6c757d;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btnContentConfirmedWhiteDelAll:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.btnContentConfirmedDelAll {
  background: linear-gradient(135deg, #dc3545, #c82333);
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  color: white;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btnContentConfirmedDelAll:hover {
  background: linear-gradient(135deg, #c82333, #a02622);
  transform: translateY(-1px);
}
</style>